<template>
    <div class="home" :style="app">
      <div class="item-box">
        <template>
          <div :class="reviewDisable ? 'disable-item':''" class="card-item"  @click="goToMaterial(cardList[0])">
            <img :src="cardList[0].img" alt>
            <p>推免生预报名</p>
          </div>
        </template>
        <template>
          <div :class="materialDisable ? 'disable-item':''" class="card-item" @click="goToMaterial(cardList[1])">
            <img :src="cardList[1].img" alt>
            <p>上传体检报告</p>
          </div>
        </template>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "homepage",
    data(){
      return{
        app: {
          backgroundImage: 'url(' + require('../assets/image/homebg.jpg') + ')',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '100% 100%'
        },
        reviewDisable:false,
        materialDisable:false,
        cardList:[
          {
            img:require('../assets/image/first_apply.png'),
            text:'推免生预报名',
            name: 'candidates',
            disable:true,
          },
          {
             img:require('../assets/image/apply.png'),
            text:'上传体检报告',
            name: 'reportMedical',
            disable:true,
          },
        ],
        // paramsRR:{},
        // paramsMM:{},
      }
    },
    methods: {
    //   goToReview(item){
    //     this.$http.get("/api/checkReviewApply").then(res=>{
    //       let response = res.data.data
    //       if(this.reviewDisable)  {
  
    //       }else if(response){
    //         this.$router.push({name:item.name})
    //       }else{
    //         this.$message.error(`您不能申请初试成绩复查!`)
    //       }
    //     })
  
    //   },
      goToMaterial(item) {
        console.log(item);
        // if(!this.materialDisable){
           this.$router.push({name:item.name})
        // }
      },
      // //检测是否调剂生
      // getCheckReviewApply(){
      //   this.$http.get("/api/checkReviewApply").then(res => {
      //       if(!this.isCheck){
      //         this.$message.warning(`您不能申请初试成绩复查!`)
      //       }
      //
      //   });
      // },
      // //检测是否调剂生
      // getCheckMaterial(){
      //   this.$http.get("/api/checkMaterial").then(res => {
      //    this.materialDisable = !res.data.data
      //   });
      // },
      //硕士 初试和复试材料,检测是否开放 isOpen如果为0，则按钮变灰，如果现在时间超出申请时间，也变灰
    //   getMasterMaterialReview(){
    //     this.$http.get("/api/zsReviewApply/review/time").then(res => {
    //       let newDate=new Date().getTime()
    //       let isOpen = res.data.data.isOpen
    //       let startTime = new Date (res.data.data.startTime).getTime()
    //       let endTime = new Date(res.data.data.endTime).getTime()
    //       if(endTime < newDate || startTime > newDate || isOpen ===0){
    //         this.reviewDisable = true
    //       }
    //     });
    //     this.$http.get("/api/zsMaterial/material/time").then(res => {
    //       let isOpen = res.data.data.isOpen
    //       if(isOpen ===0){
    //         this.materialDisable = true
    //       }
    //       console.log(isOpen,this.materialDisable)
    //     });
    //   },
  
    },
    mounted() {
    //   this.getMasterMaterialReview();
  
    },
    computed:{
     
    }
  }
  </script>
  
  <style scoped lang="scss">
  .home{
    display: flex;
    width: 100%;
    // height: 100vh;
      height: calc(100% - 72px);
    padding-top: 30px !important;
    justify-content: space-around;
    .item-box{
      padding-top: 60px;
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      flex-direction: row;
      justify-content: center;
      .card-item{
        &:hover{
          //transform: scale(1.06);
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2),
          0 0px 6px rgba(0, 0, 0, 0.1);
          p{
         
            color: #0092ff;
          }
          border-color:#0092ff ;
        }
        width: 230px;
        height: 260px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        align-content: space-between;
        border-radius: 10px;
        background-color: white;
        text-align: center;
        padding: 20px;
        cursor: pointer;
        transition: 0.7s;
        box-shadow: 0 1px 4px rgba(0,0,0,0.2);
        margin-right: 100px;
        margin-bottom: 100px;
        border: 1px solid #d2d2d2;
        img{
          height: 150px;
        }
        p{
          margin-top:15px;
          font-size: 20px;
          margin-bottom:20px;
        }
        span{
          color: #989898;
        }
      }
  
      .disable-item{
        cursor: no-drop;
        img{
          filter: grayscale(100%);
        }
        p{
          color: #d2d2d2;
        }
      }
      .disable-item:hover{
        p{
          color: #d2d2d2 !important;
        }
      }
    }
    .msg-box{
      width: 40%;
      display: flex;
      flex-direction: column;
      .msg-item{
        width: 100%;
        border-radius: 10px;
        box-shadow: 0 1px 4px rgba(0 ,0, 0, .2);
        &-title{
          background-color: #eff7ff;
          padding: 10px 20px;
          i{
            color: #52a7ff;
            font-size: 24px;
            vertical-align: middle;
          }
          span{
            font-weight: bold;
            font-size: 16px;
          }
        }
        &-content{
          height: 360px;
          overflow: auto;
        }
      }
      .msg-item:first-child{
        margin-bottom: 30px;
      }
    }
  }
  
  </style>
  